import { gql } from "@apollo/client";
import { useResettableMutation } from "../useResettableMutation";
import { getErrors } from "../../utils/apolloError";
import { AsyncActionStatus } from "../../models/AsyncActionStatus";
import {
  RequestRejectedPermitToDig,
  RequestRejectedPermitToDigVariables,
} from "./__generated__/RequestRejectedPermitToDig";

const REQUEST_REJECTED_PERMIT = gql`
  mutation RequestRejectedPermitToDig(
    $id: String!
    $permitDataInput: PermitDataInput
    $documentIds: [String!]
    $asBuiltRequired: Boolean!
    $areas: [AreaInput!]
    $permitAssignmentInputs: [PermitAssignmentInput!]
    $calibrationCertificate: CalibrationCertificateInput
    $sitePhotos: [SitePhotoInput]
    $sitePhotoIds: [String]
    $permitRegisterId: String!
    $permitTypeId: String!
    $fieldValues: [PermitFieldValueInput]
  ) {
    requestRejectedPermitToDig(
      input: {
        id: $id
        permitDataInput: $permitDataInput
        documentIds: $documentIds
        asBuiltRequired: $asBuiltRequired
        areas: $areas
        permitAssignmentInputs: $permitAssignmentInputs
        calibrationCertificate: $calibrationCertificate
        sitePhotos: $sitePhotos
        sitePhotoIds: $sitePhotoIds
        permitRegisterId: $permitRegisterId
        permitTypeId: $permitTypeId
        fieldValues: $fieldValues
      }
    ) {
      permitToDig {
        id
      }
    }
  }
`;

export function useRequestRejectedPermit() {
  const [mutate, { loading, data, error, reset, called }] = useResettableMutation<
    RequestRejectedPermitToDig,
    RequestRejectedPermitToDigVariables
  >(REQUEST_REJECTED_PERMIT, {
    errorPolicy: "all",
  });
  return {
    mutate,
    data,
    status: {
      loading,
      reset,
      called,
      errors: getErrors(error),
      successful: !error && data ? true : false,
    } as AsyncActionStatus,
  };
}
